import { SIGN_IN_MENU_ITEMS } from "~/models/signin";
import { LinkButton } from "./LinkButton";

export function Mobile(props: {
  userName?: string;
  color?: string;
  backgroundColor?: string;
}) {
  const secondaryBackgroundColor = "#49516f";

  if (props.userName) {
    return (
      <div className="tw:flex tw:flex-col tw:items-center tw:justify-center tw:gap-3 tw:w-full tw:h-full">
        <LinkButton
          label={`Welcome, ${props.userName}`}
          link="/profile"
          color={props.color}
          backgroundColor={props.backgroundColor}
        />

        {SIGN_IN_MENU_ITEMS.map((item) => (
          <LinkButton
            key={item.label}
            label={item.label}
            link={item.link}
            color={props.color}
            backgroundColor={secondaryBackgroundColor}
          />
        ))}
      </div>
    );
  }

  return (
    <LinkButton
      label="Sign In/Create an Account"
      link="/profile"
      color={props.color}
      backgroundColor={props.backgroundColor}
    />
  );
}
